"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMessage = void 0;
var common_1 = require("@timeflies/common");
var joi = __importStar(require("joi"));
var createMessage = function (action, payloadSchema) {
    var messageCreator = function (payload) { return ({ action: action, payload: payload }); };
    messageCreator.action = action;
    messageCreator.match = function (message) { return message.action === action; };
    messageCreator.schema = joi.object({
        action: action,
        payload: payloadSchema
    });
    messageCreator.withResponse = function () { return createMessageWithResponse(action, payloadSchema); };
    return messageCreator;
};
exports.createMessage = createMessage;
var createMessageWithResponse = function (action, messagePayloadSchema) {
    var messageCreator = function (payload) { return ({
        get: function () { return ({
            action: action,
            payload: payload,
            requestId: common_1.createId()
        }); }
    }); };
    messageCreator.action = action;
    messageCreator.match = function (message) { return message.action === action; };
    messageCreator.schema = joi.object({
        action: action,
        payload: messagePayloadSchema,
        requestId: joi.string().required()
    });
    messageCreator.createResponse = function (requestId, payload) { return ({ action: action, payload: payload, requestId: requestId }); };
    return messageCreator;
};
